// extracted by mini-css-extract-plugin
module.exports = {"summary-adjustment":"_15KHMI0SkeUjtHOP4P-x-d","amount":"_2s7Ui7ogJaJvFCGHgdMsJ2","title":"_2qY0JqCaCXQWvwj17BoOmn"};